import { ShieldCheck, Award, Users, Flame } from "lucide-react";
import { BRAND } from "@/lib/brand";

const features = [
  {
    icon: ShieldCheck,
    title: "Fichiers sur mesure",
    text: "Chaque cartographie est développée pour votre véhicule, jamais générique.",
  },
  {
    icon: Award,
    title: "Matériel pro",
    text: "Outils de diagnostic et reprogrammation professionnels, multimarques.",
  },
  {
    icon: Users,
    title: "Suivi personnalisé",
    text: "Du diagnostic à l'essai routier, on vous accompagne à chaque étape.",
  },
  {
    icon: Flame,
    title: "Passion brute",
    text: "Une équipe d'enthousiastes pour qui chaque moteur est un défi.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 px-6 md:px-12 border-y border-white/5"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Image side */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={BRAND.aboutImage}
              alt="L'atelier LAD Performance"
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/50 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block stripes-yellow w-32 h-32 opacity-80" />
          <div className="absolute top-6 left-6 bg-yellow-500 text-black px-4 py-2 font-display text-lg tracking-wide">
            ATELIER · 66690
          </div>
        </div>

        {/* Text side */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-yellow-500" />
            <span className="text-yellow-500 text-xs uppercase tracking-[0.4em]">
              02 — L'atelier
            </span>
          </div>
          <h2 className="font-display text-white text-5xl md:text-6xl leading-[0.95] mb-8">
            Un garage de passionnés,<br />
            <span className="text-yellow-500">pas une chaîne.</span>
          </h2>
          <p className="text-zinc-300 text-base md:text-lg leading-relaxed mb-6 max-w-2xl">
            Implanté à Saint-André dans les Pyrénées-Orientales, <strong className="text-white">LAD Performance</strong> est l'atelier référence pour tous ceux qui veulent
            tirer le meilleur de leur véhicule. Reprogrammation moteur, cartographie
            éthanol E85, dépollution, diagnostic et préparation : on intervient sur
            toutes les marques, du quotidien à la sportive.
          </p>
          <p className="text-zinc-400 text-base leading-relaxed mb-10 max-w-2xl">
            Notre approche est simple&nbsp;: analyser, conseiller, exécuter. Pas de
            promesse marketing, juste un travail soigné, traçable et garanti.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((f) => (
              <div
                key={f.title}
                data-testid={`about-feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-black/40 border border-white/10 hover:border-yellow-500/50 p-5 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <f.icon className="w-6 h-6 text-yellow-500 shrink-0 mt-1" />
                  <div>
                    <h3 className="font-display text-xl text-white tracking-wide mb-1">
                      {f.title}
                    </h3>
                    <p className="text-zinc-400 text-sm leading-relaxed">{f.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
